var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRollingDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.363,
    height: 43.944,
    viewBox: "0 0 39.363 43.944",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rolling-disable",
    transform: "translate(-849.793 -374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_17_168",
    "data-name": "Component 17 \\u2013 168",
    transform: "translate(850 374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bed-svgrepo-com",
    transform: "translate(0 11.869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_960",
    "data-name": "Group 960",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_959",
    "data-name": "Group 959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M18.006,145.022a2.491,2.491,0,0,1-2.2-2.645c-.019-.614-.023-1.233-.009-1.873H9.59a2.452,2.452,0,0,0,.473-1.479,1.97,1.97,0,0,0-1.717-2.15H8.322a3.182,3.182,0,0,0,2.043-3.133c.027-1.807-1.122-3.3-2.566-3.332s-2.635,1.4-2.662,3.212a3.213,3.213,0,0,0,2.04,3.253H4.025V125.923a1,1,0,0,0-.87-1.089H.87A1,1,0,0,0,0,125.923l.015,21.01a1.232,1.232,0,0,0,1.073,1.344H2.959v.787a.8.8,0,0,0,.7.871H7.146a.8.8,0,0,0,.7-.871v-.787H31.205v.787a.8.8,0,0,0,.7.871h3.491a.8.8,0,0,0,.7-.871v-.787h1.644a1.232,1.232,0,0,0,1.073-1.344V145C35.042,145.007,19.265,145.022,18.006,145.022Z",
    transform: "translate(0 -124.834)",
    fill: "#9a9a9a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_962",
    "data-name": "Group 962",
    transform: "translate(10.757 5.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_961",
    "data-name": "Group 961",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M159.636,188.1h0a1.2,1.2,0,0,0-1.845-.543h0l-3.942,3.055-4.635-2.658,2.176.48a23.381,23.381,0,0,1,1.075-3.19l-5.044-.116a2.139,2.139,0,0,0-1.911,2.3l-.061,4.187a2.182,2.182,0,0,0,1.842,2.391l3.2.074q.026-.389.059-.763l-2.285-2.22,5.119,2.935a1.119,1.119,0,0,0,1.264-.1l4.553-3.529A1.937,1.937,0,0,0,159.636,188.1Z",
    transform: "translate(-145.447 -185.133)",
    fill: "#9a9a9a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964",
    transform: "translate(16.007 4.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M246.27,180.834c-5.1-1.841-13.324-3.2-16.409-3.093a15.653,15.653,0,0,0-1.833,4.417l.545.12,3.525-2.732a2.343,2.343,0,0,1,3.617,1.064,3.8,3.8,0,0,1-.85,4.526l-4.553,3.529a2.14,2.14,0,0,1-2.732,0l-.478-.464c-.041.853-.052,1.754-.022,2.711a.765.765,0,0,0,.673.81h21.3a.74.74,0,0,0,.665-.708l.43-3.31A6.293,6.293,0,0,0,246.27,180.834Z",
    transform: "translate(-227.063 -177.735)",
    fill: "#9a9a9a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(29.036 0) rotate(76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Core",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rotate-right",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M12.179,4.766,7.413,0V3.283a8.427,8.427,0,0,0,0,16.732V17.9a6.334,6.334,0,0,1,0-12.5v4.13l4.766-4.766Z",
    fill: "#9a9a9a",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("line", {
    id: "Line_250",
    "data-name": "Line 250",
    x1: 37,
    y2: 37,
    transform: "translate(850.5 380.237)",
    fill: "none",
    stroke: "#848484",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollingDisable);
export default __webpack_public_path__ + "static/media/rolling-disable.c31fe7c3c2e8d0e209e0d4ba69e635af.svg";
export { ForwardRef as ReactComponent };